import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityCardDependabotAlertsTable: ExtensionDefinition =
  EntityCardBlueprint.make({
    name: 'dependabot-alerts-table',
    params: {
      loader: async () =>
        import('./dependabot-alerts').then(m => (
          <m.EntityDependabotAlertsTable />
        )),
    },
  });

export const entityCardDependabotAlertsWidget: ExtensionDefinition =
  EntityCardBlueprint.make({
    name: 'dependabot-alerts-widget',
    params: {
      loader: async () =>
        import('./dependabot-alerts').then(m => (
          <m.EntityDependabotAlertsWidget />
        )),
    },
  });
